import { useState } from "react";
import { Mail, MapPin, Instagram } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { SectionHead } from "../components/Motion";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", order_number: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", phone: "", subject: "", order_number: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    }
    setLoading(false);
  };

  const input = "mt-1.5 w-full bg-[#FBF7F1] border border-[#7E1E3F]/25 rounded-xl px-4 py-3 text-sm text-[#2E1A22] outline-none focus:border-[#7E1E3F]/60 placeholder:text-[#857078]";

  return (
    <div className="pt-28 pb-24 max-w-5xl mx-auto px-4 sm:px-6 min-h-screen" data-testid="contact-page">
      <SectionHead overline="Contact" title="We're Here to Help" center testid="contact-head" />
      <div className="grid md:grid-cols-3 gap-4 mb-12">
        {[[Mail, "Email", "founder@savyron.in", "mailto:founder@savyron.in"],
          [MapPin, "Registered Office", "Plot No. 87, Sector 62, Noida – 201309", null],
          [Instagram, "Instagram", "@savyron.in", "https://www.instagram.com/savyron.in"]].map(([Icon, t, v, href]) => (
          <div key={t} className="card-surface rounded-2xl p-6 text-center">
            <Icon className="mx-auto text-[#7E1E3F]" size={20} />
            <p className="mt-3 text-xs font-mono-lux tracking-[0.2em] uppercase text-[#857078]">{t}</p>
            {href ? <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="text-sm text-[#45303A] mt-1 block hover:text-[#7E1E3F] transition-colors">{v}</a>
              : <p className="text-sm text-[#45303A] mt-1">{v}</p>}
          </div>
        ))}
      </div>
      <form onSubmit={submit} className="card-surface rounded-2xl p-6 sm:p-8 grid sm:grid-cols-2 gap-5" data-testid="contact-form">
        <label><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Name</span>
          <input required className={input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" /></label>
        <label><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Email</span>
          <input required type="email" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" /></label>
        <label><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Phone (optional)</span>
          <input className={input} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" /></label>
        <label><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Order Number (optional)</span>
          <input className={input} placeholder="SAV-2026-…" value={form.order_number} onChange={(e) => setForm({ ...form, order_number: e.target.value })} data-testid="contact-order" /></label>
        <label className="sm:col-span-2"><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Subject</span>
          <input className={input} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" /></label>
        <label className="sm:col-span-2"><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Message</span>
          <textarea required rows={5} className={input} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" /></label>
        <div className="sm:col-span-2 text-center">
          <button disabled={loading} className="bg-[#7E1E3F] text-[#FFFFFF] font-semibold text-sm tracking-wider uppercase rounded-full px-10 py-4 hover:bg-[#5C1230] transition-colors disabled:opacity-60" data-testid="contact-submit">
            {loading ? "Sending…" : "Send Message"}
          </button>
        </div>
      </form>
    </div>
  );
}
